'use client'

import { useEffect } from 'react'

import { setBrowserLoggerConfig } from '@mntn-dev/logger'

export function LoggerConfig({
  consoleMethods,
}: {
  consoleMethods?: string[]
}) {
  useEffect(() => {
    if (consoleMethods) {
      setBrowserLoggerConfig({ consoleMethods: consoleMethods.join(',') })
    }
  }, [consoleMethods])

  return null
}
